import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=70e95748&scoped=true&"
import script from "./edit-profile.vue?vue&type=script&lang=js&"
export * from "./edit-profile.vue?vue&type=script&lang=js&"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=70e95748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e95748",
  null
  
)

export default component.exports